import styled from 'styled-components';

import CloseIcon from '@mui/icons-material/Close';
import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const Z_INDEX = 2000;
const ICON_WIDTH = 28;
const MIN_MODAL_HEIGHT = 300;

export const DialogOuterContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: transparent;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: ${Z_INDEX};
`;

export const StyledCloseIcon = styled(CloseIcon)`
    width: ${ICON_WIDTH}px;
    height: ${ICON_WIDTH}px;
    cursor: pointer;
`;

export const HeaderCloseIconContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
`;

export const DialogBackground = styled.div`
    background: ${({ theme }) => theme.Surface.Opposite.primary};
    height: 100vh;
    left: 0;
    opacity: 0.5;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: ${Z_INDEX - 1};
`;

export const DialogContent = styled.div<{ $isLoading: boolean }>`
    ${BaseStyle.Mixins.gaps.medium}
    background: ${({ theme }) => theme.Surface.primary};
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: ${({ $isLoading }) => ($isLoading ? 'center' : 'initial')};
    align-items: ${({ $isLoading }) => ($isLoading ? 'center' : 'initial')};
    min-width: ${MIN_MODAL_HEIGHT}px;
    min-height: ${({ $isLoading }) => ($isLoading ? `${MIN_MODAL_HEIGHT}` : 'none')};
    max-width: initial;
    max-height: initial;
    padding: 16px;
    border-radius: 16px;
    z-index: ${Z_INDEX};

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 548px;
        padding: 16px;
    }
`;

export const ModalHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24b']};
`;

export const Subtitle = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle3};
    margin-top: 0;
`;

export const ViewingGuideLabel = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    text-transform: uppercase;
    color: ${({ theme }) => theme.Text.secondary};
`;

export const InnerContent = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
`;

export const SelectBroadcastsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.large}
    }
`;

export const BroadcastsLink = styled.a`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    color: ${({ theme }) => theme.Utility.cta};
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 36px;

    && {
        color: ${({ theme }) => theme.Utility.cta};
    }

    &&:hover {
        color: ${({ theme }) => theme.Utility.cta};
    }
`;

export const NoBroadcastsAvailableMessage = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body2};
    color: ${({ theme }) => theme.Text.secondary};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px 12px;
`;

export const HowToWatchPanel = styled.div`
    align-items: center;
    background: ${({ theme }) => theme.Surface.primary};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    display: flex;
    padding: 8px;
`;
